import { Accordion, AccordionDetails, AccordionSummary, Box, FormControlLabel, Grid } from '@mui/material';
import { ActionCreatorWithPayload } from '@reduxjs/toolkit';
import React from 'react';
import { WO2Checkbox } from 'src/common';
import DateRangePicker from 'src/common/components/DateRangePicker';
import { DateRange } from 'src/store';
import { BaseReportComponentProps, MdaReportTypeField, MdaReportTypes } from '../../store/types';
import { ExpandMore } from '@mui/icons-material';
import { ReportGroupingOption } from '../ReportGroupingOption';

export interface ContributionsAndWithdrawalsProps extends BaseReportComponentProps {
  setDateRangeContributionsAndWithdrawalsParameter: ActionCreatorWithPayload<DateRange, string>;
  setContributionsAndWithdrawalsSelectedParameter: ActionCreatorWithPayload<boolean, string>;
  expandContributionsAndWithdrawals: () => void;
}

export const ContributionsAndWithdrawals = ({
  parameters,
  setDateRangeContributionsAndWithdrawalsParameter,
  setContributionsAndWithdrawalsSelectedParameter,
  setGroupConsolidatedOption,
  expandContributionsAndWithdrawals,
  createReportSortRequest,
}: ContributionsAndWithdrawalsProps) => {
  const handleClickContributionsAndWithdrawalsSelect = () => {
    setContributionsAndWithdrawalsSelectedParameter(!parameters.selectedReports?.contributionsAndWithdrawals.selected);
    createReportSortRequest(
      !parameters.selectedReports?.contributionsAndWithdrawals.selected,
      MdaReportTypes.ContributionsAndWithdrawals.id,
      MdaReportTypes.ContributionsAndWithdrawals.displayName
    );
  };

  const handleClickDateRangeForContributionsAndWithdrawals = (dates: DateRange) => {
    setDateRangeContributionsAndWithdrawalsParameter(dates);
  };

  const header = () => {
    return (
      <>
        <Grid container>
          <FormControlLabel
            aria-label="Acknowledge"
            onClick={(event) => event.stopPropagation()}
            onFocus={(event) => event.stopPropagation()}
            control={
              <WO2Checkbox
                color="primary"
                checked={parameters.selectedReports?.contributionsAndWithdrawals.selected}
                onChangeHandler={handleClickContributionsAndWithdrawalsSelect}
              />
            }
            sx={{ flex: 1 }}
            label="Contributions & Withdrawals"
          />
        </Grid>
        <div onClick={(e) => e.stopPropagation()}>
          <DateRangePicker
            dateRange={{
              dateFrom: parameters?.selectedReports.contributionsAndWithdrawals?.fromDate,
              dateTo: parameters?.selectedReports.contributionsAndWithdrawals?.toDate,
              dateRangeType: parameters?.selectedReports.contributionsAndWithdrawals?.dateRangeType,
            }}
            setDateRange={handleClickDateRangeForContributionsAndWithdrawals}
            inceptionDate={parameters.inceptionDate}
          />
        </div>
      </>
    );
  };

  if (setGroupConsolidatedOption) {
    return (
      <Accordion
        onChange={expandContributionsAndWithdrawals}
        expanded={parameters.selectedReports.contributionsAndWithdrawals.expanded || false}
        elevation={0}
      >
        <AccordionSummary expandIcon={<ExpandMore />}>{header()}</AccordionSummary>
        <AccordionDetails>
          <Grid container direction="column">
            <Grid item>
              <ReportGroupingOption
                value={parameters.selectedReports.contributionsAndWithdrawals.groupOption}
                setGroupConsolidatedOption={setGroupConsolidatedOption}
                report={MdaReportTypeField.ContributionsAndWithdrawals}
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    );
  }
  return (
    <Box ml={6} display="flex" alignItems="center" mt={1} mb={1}>
      {header()}
    </Box>
  );
};
